import {AxiosInstance} from "axios";
import CustomField from "../model/customField/CustomField";
import {CreateUpdateCustomFieldApiDto} from "./model/rest";

export default class CustomFieldApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch lead custom fields.
	 * @returns {Promise<CustomField[]>} Promise containing lead custom fields.
	 */
	fetchLeadCustomFields(): Promise<CustomField[]> {
		const url = `/api/web/leads/custom_fields`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(CustomField.fromJson));
	}

	/**
	 * Fetch job custom fields.
	 * @returns {Promise<CustomField[]>} Promise containing job custom fields.
	 */
	fetchJobCustomFields(): Promise<CustomField[]> {
		const url = `/api/web/jobs/custom_fields`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(CustomField.fromJson));
	}

	/**
	 * Fetch Partner Brand custom fields.
	 * @returns {Promise<CustomField[]>} Promise containing Partner Brand custom fields.
	 */
	fetchPartnerBrandCustomFields(): Promise<CustomField[]> {
		const url = `/api/web/partner_brands/custom_fields`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(CustomField.fromJson));
	}

	/**
	 * Create job custom field
	 * @param {CreateUpdateCustomFieldApiDto} data
	 * @returns {Promise<CustomField>}
	 */
	createJobCustomField(data: CreateUpdateCustomFieldApiDto):Promise<CustomField> {
		const url = `/api/web/jobs/custom_fields`;
		return this.axiosInstance.post(url, data).then((resp) => CustomField.fromJson(resp.data));
	}

	/**
	 * Create lead custom field
	 * @param {CreateUpdateCustomFieldApiDto} data
	 * @returns {Promise<CustomField>}
	 */
	createLeadCustomField(data: CreateUpdateCustomFieldApiDto):Promise<CustomField> {
		const url = `/api/web/leads/custom_fields`;
		return this.axiosInstance.post(url, data).then((resp) => CustomField.fromJson(resp.data));
	}

	/**
	 * Create Partner Brand custom field
	 * @param {CreateUpdateCustomFieldApiDto} data
	 * @returns {Promise<CustomField>}
	 */
	createPartnerBrandCustomField(data: CreateUpdateCustomFieldApiDto): Promise<CustomField> {
		const url = `/api/web/partner_brands/custom_fields`;
		return this.axiosInstance.post(url, data).then((resp) => CustomField.fromJson(resp.data));
	}

	/**
	 * Update job custom field
	 * @param {string} customFieldId
	 * @param {CreateUpdateCustomFieldApiDto} data
	 * @returns {AxiosPromise<any>}
	 */
	updateJobCustomField(customFieldId: string, data: CreateUpdateCustomFieldApiDto) {
		const url = `/api/web/jobs/custom_fields/${customFieldId}`;
		return this.axiosInstance.put(url, data);
	}

	/**
	 * Update lead custom field
	 * @param {string} customFieldId
	 * @param {CreateUpdateCustomFieldApiDto} data
	 * @returns {AxiosPromise<any>}
	 */
	updateLeadCustomField(customFieldId: string, data: CreateUpdateCustomFieldApiDto) {
		const url = `/api/web/leads/custom_fields/${customFieldId}`;
		return this.axiosInstance.put(url, data);
	}

	/**
	 * Update Partner Brand custom field
	 * @param {string} customFieldId
	 * @param {CreateUpdateCustomFieldApiDto} data
	 * @returns {AxiosPromise<any>}
	 */
	updatePartnerBrandCustomField(customFieldId: string, data: CreateUpdateCustomFieldApiDto) {
		const url = `/api/web/partner_brands/custom_fields/${customFieldId}`;
		return this.axiosInstance.put(url, data);
	}
}